import { observeVideo, attachVideoSource } from './nv-media-loading.js';
function setupVideos(root = document) {
  root.querySelectorAll('.nv-collection-hero__story-video').forEach(panel => {
    if (panel.dataset.videoReady) return;
    const video = panel.querySelector('video');
    const button = panel.querySelector('button');
    if (!video || !button) return;
    panel.dataset.videoReady = 'true';
    video.muted = true;
    button.hidden = false;
    const sync = () => {
      const label = video.paused ? 'Přehrát video' : 'Pozastavit video';
      button.setAttribute('aria-label', label);
      button.title = label;
      button.innerHTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">${video.paused ? '<path d="M8 5v14l11-7z"/>' : '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>'}</svg>`;
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    const playback = observeVideo(panel, () => attachVideoSource(video));
    button.addEventListener('click', () => { if (video.paused) playback.play(); else playback.pause(); });
    sync();
  });
}
setupVideos();
document.addEventListener('shopify:section:load', e => setupVideos(e.target));
